export const UNPIN_POST_REQUEST = 'post/UNPIN_REQUEST';
export const UNPIN_POST_SUCCESS = 'post/UNPIN_SUCCESS';
export const UNPIN_POST_FAILURE = 'post/UNPIN_FAILURE';
